import React, { Component, forwardRef } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from "react-redux";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import * as auth from "../../store/ducks/auth.duck";
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { reduxForm } from 'redux-form'
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Divider, Link } from '@material-ui/core';
import MaterialTable from 'material-table';
import asyncValidate from './asyncValidate';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import moment from 'moment';
import axios from "axios";

import Tooltip from '@material-ui/core/Tooltip';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { referralParamsSubscriber } from '../../services/dataTransferService'
import axiosAPI from '../../api/Scoreboardapi';
import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from './Modal';
import { Redirect, Route, Switch } from "react-router-dom";

import Loader from 'react-loader-advanced';
import { Helmet } from "react-helmet";
import LeftMenu from "./LeftMenu";

const osaRiskValue = { 0: 'Low Risk', 1: 'Medium Risk', 2: 'High Risk' }

library.add(fas)

// Styles
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} color="primary" ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} color="primary" ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
class ScreenedPatient extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: [],
      currentPage: 0,
      currentSortOrder: { defaultSort: 'desc' },
      sortBy: "id",
      rowsPerPage: 10,
      totalRecords: 0,
      popoverOpen: false,
      selectedPtKey: 0,
      panel3: 'panel3',
      showFilter: false,
      salesOrderDiv: null,
      alert: '',
      showModal: false,
      isLoading: true,
      isLoadingNonPap: true,
      statusParam: "",
      complianceRiskParam: "",
      sortByNonPap: 'id',
      isLoadingDocument: false,
      isLeftMenuVisible: false,
      breakdownClass: '',
      trendsClass: '',
      detailsClass: '',
      isOpen: true,
      isPatientNoteModelOpen: false,
      patientData: '',
      isOpenOsaRiskPopover: false,
      isLoaderActive: true,
      isUpdateModel: false,
      updatePatientData: {},
      isOpenScreenerDataPopover: false,
      screenerData: [],
      isPendingSleepyDropDownOpen: false,
      isPendingSleepStudyDataExist: null,
      isPatientNoteDelete: false,
      patientNoteData: {
        "PtKey": '',
        "NickName": ''
      },
      sleepScreenerAccess: '',
      isScrrenedPatientListApiCall: true,
      isPdfOpen: false
    };
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.changeSearch = this.changeSearch.bind(this);
    this.state.salesOrderDiv = React.createRef()
  }

  toggleLeftMenuDesktop = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  componentDidMount() {
    this.props.checkForMenuItemAccessRequest()
    this.props.saveSalesFilter([], true)
    // Commented as it was causing double API call
    // this.props.clearFilter({
    //   "isFilterClear": true,
    // });

    referralParamsSubscriber.subscribe((data) => {
      setTimeout(() => {
        if (data == "") {
          if (this.state.sleepScreenerAccess != '' && this.state.isScrrenedPatientListApiCall) {
            this.props.fetchScreenedPatientListRequest({ 'referralParam': this.props.referralParam, "organization": this.props.organizationParam, "isAdmin" : JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).roleName == "super-admin" ? 1 : 0 })
          }
        } else {
          this.props.fetchScreenedPatientListRequest({ 'referralParam': data, "organization": this.props.organizationParam, "isAdmin" : JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).roleName == "super-admin" ? 1 : 0 })
        }
      }, 1000)
    })
    if (this.props.sleepScreenerAccess != 0) {
      // var columnHeader = document.getElementsByClassName('MuiTableCell-head');
      // columnHeader[2].innerHTML += '<div><span id="test-main-osq" style="cursor:pointer"><svg aria-hidden="true" focusable="false" data-prefix="fa" data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg></span><div>';

      var divtest = document.createElement("span");
      divtest.innerHTML = '<p class="MuiButtonBase-root MuiTableSortLabel-root" id="test-main-osq" style="cursor:pointer"><svg aria-hidden="true" focusable="false" data-prefix="fa" data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg></p>';
      var columnHeader = document.getElementsByClassName('MuiTableCell-head')[2]; //Selected OSA risk column
      columnHeader.appendChild(divtest);
      // columnHeader.style.textAlign = 'center';

      var columnOsa = document.getElementById('test-main-osq');
      columnOsa.addEventListener("click", this.openOsaPopup);
    }
  }
  handleResetFilter = () => {
    this.setState({ showFilter: false });
    this.setState({ isLoading: true });
    this.props.clearFilter({ "isFilterClear": true });
    this.props.saveSalesFilter([], true)
    this.props.fetchScreenedPatientListRequest({ 'referralParam': this.props.referralParam, "organization": this.props.organizationParam, "isAdmin" : JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).roleName == "super-admin" ? 1 : 0 })
  }

  openOsaPopup = () => {
    this.setState({ isOpenOsaRiskPopover: true });
  }

  downloadFile = (fileUrl, fileName) => {
    axios({
      url: fileUrl,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    }).catch((e) => {
      this.displayAlert('No document found');
    });
  }

    componentWillReceiveProps(nextProps) {
    if ((nextProps.checkForMenuItemAccess.success != undefined && nextProps.checkForMenuItemAccess.success == true)) {
      var storedUserData = localStorage.getItem('persist:userData');
      var parsedStoreUserData = JSON.parse(storedUserData);

      var user = JSON.parse(parsedStoreUserData.user);
      user.sleepScreenerAccess = nextProps.checkForMenuItemAccess.sleepScreenerAccess;
      user.globalSummaryAccess = nextProps.checkForMenuItemAccess.globalSummaryAccess;

      parsedStoreUserData.user = JSON.stringify(user);
      var newUserData = JSON.stringify(parsedStoreUserData);
      localStorage.setItem("persist:userData", newUserData);
      this.setState({ sleepScreenerAccess: nextProps.checkForMenuItemAccess.sleepScreenerAccess });
      this.setState({ globalSummaryAccess: nextProps.checkForMenuItemAccess.globalSummaryAccess });
      if (nextProps.checkForMenuItemAccess.sleepScreenerAccess !== 0 && this.state.sleepScreenerAccess == '') {
        this.setState({ isScrrenedPatientListApiCall: false })
        this.props.fetchScreenedPatientListRequest({ 'referralParam': this.props.referralParam, "organization": this.props.organizationParam, "isAdmin" : JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).roleName == "super-admin" ? 1 : 0 })
      }
    }
    if ((nextProps.patientNoteDelete.success != undefined && nextProps.patientNoteDelete.success == true) && this.state.isPatientNoteDelete) {
      this.displayAlert("Completed!", "Note deleted successfully.", 'success')
      this.props.fetchPatientNotesListRequest(this.state.patientNoteData)
      this.setState({ isPatientNoteDelete: false });
    }

    if (nextProps.userData && nextProps.userData.length > 0) {
      this.setState({ isLoading: false });
      this.setState({ user: nextProps.userData })
    } else {
      this.setState({ user: [] })
    }
    if (nextProps.patientScreenerData != null && nextProps.patientScreenerData.length > 0) {
      this.setState({ screenerData: nextProps.patientScreenerData[0] })
    }
    if (this.state.isPdfOpen && nextProps.locationPath != undefined && nextProps.locationPath.liScreenerDataResponse == null) {
      this.setState({ isPdfOpen: false })
      // window.open(process.env.REACT_APP_API_IMAGE_URL + nextProps.locationPath.message, "_blank")
      let fileURL = process.env.REACT_APP_API_IMAGE_URL + nextProps.locationPath.message;
      let filename = nextProps.locationPath.message.split('/').pop();
      filename = nextProps.locationPath.message.split('\\').pop();
      let name = filename.split('?')[0];
      this.downloadFile(fileURL, name);
    }
    if (nextProps.sloading == false) {
      this.setState({ isLoading: false });
    }
    else {
      this.setState({ isLoading: true });
    }
    if (nextProps.loading == false) {
      this.setState({ isLoading: false });
    }
    else {
      this.setState({ isLoading: true });
    }
  }

  handleChange = (panel) => (event, newExpanded) => {
    this.setState({ [panel]: newExpanded ? panel : false });
  };


  displayAlert = (title, message, type, data = []) => {
    if (type == 'success') {
      this.setState({
        alert: < SweetAlert
          success
          title={title}
          onConfirm={() => this.hideModel()} >
          {message}
        </SweetAlert>,
        showModal: !this.state.showModal,
      })
    } else if (type == 'deleteConfirmation') {
      this.setState({
        alert: <SweetAlert
          warning
          showCancel
          customClass='user-sweetalert'
          confirmBtnText={'Yes, Delete it!'}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          title={title}
          onConfirm={() => this.deletePatientNote(data)}
          onCancel={() => this.hideModel()}
          focusCancelBtn >
          {message}
        </SweetAlert>,
        showModal: !this.state.showModal,
      })
    }
    else {
      this.setState({
        alert: < SweetAlert
          error
          title={title}
          onConfirm={() => this.hideModel()} >
          {message}
        </SweetAlert>,
        showModal: !this.state.showModal,
      })
    }
  }

  hideModel = () => {
    this.setState({ alert: '', showModal: false })
  }

  enableLoading = () => {
    this.setState({ isLoading: true });
  }

  disableLoading = () => {
    setTimeout(function () {
      this.setState({ isLoading: false });
    }.bind(this), 3000)
  }

  changeOrderByPap = async (orderedColumnId, orderDirection) => {
    this.enableLoading();
    let columns = {
      0: 'patientName',
      1: 'screeningDate',
      2: 'osaRisk',
      3: 'pt_MobileNumber',
      4: 'facilityName',
      5: 'healthProvider',
      6: 'status'
    }
    let sortBy = orderedColumnId >= 0 ? columns[orderedColumnId] : columns[1]
    orderDirection = orderDirection ? orderDirection : 'asc';
    this.setState({ sortBy: sortBy, currentSortOrder: { defaultSort: orderDirection } });
    this.disableLoading();
  }

  handleTooltipClose = () => {
    this.setState({ showFilter: false });
  };

  handleToggleTooltip = () => {
    this.setState({ showFilter: !this.state.showFilter });
  };

  toggle = (ptKey, nickName) => {
    this.props.fetchPatientNotesListRequest({
      "PtKey": ptKey,
      "NickName": nickName
    })
    if (this.state.popoverOpen == true) {
      this.setState({ popoverOpen: false })
    } else {
      this.setState({ isLoadingNonPapPopover: true })
      this.setState({ popoverOpen: true });
      this.setState({ selectedPtKey: ptKey });
    }
    this.setState({ isOpenOsaRiskPopover: false })
    this.setState({ isPendingSleepStudyDataExist: null });
    this.setState({ isPendingSleepyDropDownOpen: false })
  }

  isPatientNoteModelOpen = () => {
    setTimeout(function () {
      if (document.getElementById("notes")) {
        document.getElementById("notes").focus();
      }
    }, 0);
    this.setState({ isPatientNoteModelOpen: !this.state.isPatientNoteModelOpen })
    this.setState({ isUpdateModel: false })
    this.setState({ patientData: '' })
    this.setState({ updatePatientData: {} });
  }

  deletePatientNote = (data) => {
    let noteData = {
      "PtKey": data.ptKey,
      "NickName": data.nickName,
      "PatientNotesId": data.patientNotesId
    }

    this.setState({ showModal: !this.state.showModal })
    this.props.deletePatientNoteRequest(noteData);

    this.setState({ isPatientNoteDelete: true })
    this.setState({
      patientNoteData: {
        "PtKey": data.ptKey,
        "NickName": data.nickName
      }
    })
  }

  savePatientData = (rowData) => {
    if (this.state.patientData.trim() == '') {
      this.setState({ isPatientNoteError: true });
    }
    else {
      this.setState({ isPatientNoteError: false });
      let data = {
        "StatementType": "insert",
        "PtKey": rowData.ptKey,
        "NickName": rowData.nickName,
        "Description": this.state.patientData,
        "CreatedBy": JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).name
      }
      this.props.setAddPatientNotesRequest(data);
      this.setState({ isPatientNoteModelOpen: !this.state.isPatientNoteModelOpen })

      setTimeout(
        () => this.props.fetchPatientNotesListRequest({
          "PtKey": rowData.ptKey,
          "NickName": rowData.nickName
        }),
        1000
      );
    }
  }
  savePendingSleepyStatus = async (e, followUpStatus, ptKey, nickName) => {
    this.setState({ isPendingSleepyDropDownOpen: false })
    this.setState({ isPendingSleepStudyDataExist: e.target.value })

    this.props.setPandingSleepStudyRequest({
      "PtKey": ptKey,
      "NickName": nickName,
      "FollowUpStatus": e.target.value
    })
      setTimeout(() => {
          this.props.fetchScreenedPatientListRequest({ 'referralParam': this.props.referralParam, "isAdmin": JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).roleName == "super-admin" ? 1 : 0 });
      }, 3000
      );
  }

  updateModelOpen = (data) => {
    setTimeout(function () {
      if (document.getElementById("notes")) {
        var el = document.getElementById("notes")
        el.focus()
        if (typeof el.selectionStart == "number") {
          el.selectionStart = el.selectionEnd = el.value.length;
        }
      }
    }, 0);
    this.setState({ isPatientNoteError: false });
    this.setState({ updatePatientData: data });
    this.setState({ isPatientNoteModelOpen: !this.state.isPatientNoteModelOpen })
    this.setState({ patientData: data.description })
    this.setState({ isUpdateModel: true })
  }

  setScreenerData = (ptKey, nickName, isPopup) => {
    if (isPopup) {
      this.setState({ isOpenScreenerDataPopover: true })

      this.props.fetchScreenerDataListRequest({
        "PtKey": ptKey,
        "NickName": nickName,
        "type": 'popup'
      })
      this.setState({ screenerData: [] })
    } else {
      this.setState({ isPdfOpen: true })
      this.setState({ isLoading: true })
      this.props.fetchScreenerDataListRequest({
        "PtKey": ptKey,
        "NickName": nickName,
        "type": 'pdf'
      })
    }
  }

  updatePatientData = () => {
    let updatePatientData = {
      ...this.state.updatePatientData,
      "StatementType": "update",
      'description': this.state.patientData
    }
    if (this.state.patientData.trim() == '') {
      this.setState({ isPatientNoteError: true });
    }
    else {
      this.setState({ isPatientNoteError: false });
      this.props.setAddPatientNotesRequest(updatePatientData);
      setTimeout(
        () =>
          this.props.fetchPatientNotesListRequest({
            "PtKey": updatePatientData.ptKey,
            "NickName": updatePatientData.nickName
          }),
        1000
      );
      this.isPatientNoteModelOpen();
    }

  }

  outsideClick = () => {
    this.setState({ popoverOpen: false });
    this.setState({ selectedPtKey: 0 });
    this.setState({ isPendingSleepStudyDataExist: null });
    this.setState({ isPendingSleepyDropDownOpen: false });
  }

  get_hidden_string = (name) => {
    let return_name = '';
    let explode = name.split(', ');
    let name_length = explode[0].length
    if (explode[0] && explode[0].length > 3) {
      return_name += explode[0] && explode[0].length > 3 ? explode[0].substr(0, 3) + '*'.repeat(name_length - 3) : '';
    } else {
      return_name += explode[0] && explode[0].length <= 3 ? explode[0].substr(0, 2) + '*'.repeat(name_length - 2) : '';
    }
    return_name += ', ';
    //        return_name += isset(explode[1]) && strlen(explode[1]) > 3 ? substr(explode[1], 0, 3) . str_repeat("*", strlen(explode[1]) - 3) : '';
    return_name += explode[1] ? explode[1] : '';
    return return_name;
  }

  render() {
    if (this.state.sleepScreenerAccess === 0) {
      return <Redirect to='/dashboard' />;
    }
    let selesFilterCount = this.props.salesFilter ? this.props.salesFilter.length : 0
    const salesFilterList = this.props.salesFilter ? this.props.salesFilter.map((value, key) => {
      return (
        value ? <div key={value.name} className="tooltip-block">
          <div className="filter-name"><FontAwesomeIcon icon={["fa", "filter"]} color="gray" className="mr-1" disabled={true} /> {value.name}</div>
          <div className="filter-value"> {value.value}</div>
        </div> : ''
      );
    }) : 'No data';
    const { loading } = this.props;
    const spinner = <span className="loader"></span>;
    const { showModal } = this.state;

    var leftMenuVisibleClass = '';
    if (this.state.isLeftMenuVisible) {
      leftMenuVisibleClass = 'show';
    }

    var leftMenuVisibleClass = '';
    var openIconClass = 'hide-icon-for-left-menu';
    var dashboardRightContentClass = "collapse-dashboard"
    var dashboardLeftMenuVisibleClass = 'hide-leftmenu';
    if (this.state.isOpen) {
      var leftMenuVisibleClass = 'show';
      var openIconClass = 'show-icon';
      var dashboardRightContentClass = 'expand-dashboard';
      var dashboardLeftMenuVisibleClass = 'show-leftmenu';
    }


    return (
      <>
        {
          showModal ? (
            <Modal>
              {this.state.alert}
            </Modal>
          ) : null
        }
        <Helmet>
          <title>Screened Patients | Scorecard</title>
        </Helmet>
        <div className="main-content-body dashboard">
          {window.location.pathname == '/screened-patient' &&
            <LeftMenu
              dashboardLeftMenuVisibleClass={dashboardLeftMenuVisibleClass} isOpen={this.state.isOpen}
              openIconClass={openIconClass} toggleLeftMenuDesktop={this.toggleLeftMenuDesktop}
              leftMenuVisibleClass={leftMenuVisibleClass} scrollToBreakDown={this.scrollToBreakDown}
              isScrrenedPatientPage='false'
              globalSummaryAccess={this.state.globalSummaryAccess} isPapUser={this.props.isPapUser} sleepScreenerAccess={this.state.sleepScreenerAccess}
              breakdownClass={this.state.breakdownClass} trendsClass={this.state.trendsClass} detailsClass={this.state.detailsClass} screenerClass='active'
            />
          }

          <div className={`container-fluid ${dashboardRightContentClass}`}>
            <div id="details" className="row mx-0">
              <div className="mt-3" style={{ width: "100%" }}>
                <Accordion className="accordion-title-color" ref={this.state.salesOrderDiv} expanded={this.state.panel3 === 'panel3'} onChange={this.handleChange('panel3')}>
                  <AccordionSummary
                    expandIcon={this.state.panel3 === 'panel3' ? <RemoveIcon /> : <AddIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                    style={{ backgroundColor: "#34bfa3" }}
                  >
                    <Typography className=""><FontAwesomeIcon icon={["fa", "clipboard-list"]} /><span className="ml-2 screened-patient-heading" >Screened Patients</span></Typography>
                  </AccordionSummary>
                  <AccordionDetails className="order-and-adherence-details">
                    <div className="row">
                      <div className="col-lg-12 mt-3">
                        <div className="order-and-adherence-detail">
                          <div className="form-inline p-3 jc-between" style={{ height: '65px', justifyContent: 'flex-end' }}>
                            <div className="tooltip-btn-dashboard" style={{ fontSize: '11px', color: 'gray' }}>
                              {/* <ClickAwayListener onClickAway={this.handleTooltipClose}> */}
                              <div className="d-inline sales-list-filter">
                                <Tooltip
                                  PopperProps={{
                                    disablePortal: true,
                                  }}
                                  arrow
                                  placement="left"
                                  onClose={this.handleTooltipClose}
                                  open={this.state.showFilter}
                                  disableFocusListener
                                  disableHoverListener
                                  disableTouchListener
                                  title={
                                    <React.Fragment>
                                      <div>
                                        <div>{salesFilterList}</div>
                                      </div>
                                    </React.Fragment>
                                  }
                                >
                                  <button onClick={this.handleToggleTooltip} className={selesFilterCount > 0 ? `btn btn-light btn-primary apply-filter apply-filter-tooltip` : `btn btn-light `} disabled={selesFilterCount <= 0} >
                                    <FontAwesomeIcon icon={["fa", "filter"]} color={selesFilterCount > 0 ? 'white' : 'gray'} className="mr-1" disabled={true} />
                                    {selesFilterCount > 0 ? selesFilterCount : 'No'} filter(s) applied
                                                        </button>
                                </Tooltip>
                              </div>
                              {/* </ClickAwayListener> */}
                              {
                                selesFilterCount > 0 ?
                                  <button onClick={this.handleResetFilter} className={`btn btn-light btn-elevate ml-1`} >
                                    <FontAwesomeIcon icon={["fa", "times"]} color="gray" />
                                  </button> : ''
                              }

                            </div>
                          </div>
                          <Divider />
                          <div className="font-500 order-and-adherence-details-data" style={{ height: 480 }}>
                            <div className="row p-3">
                              <div className="col-lg-12">
                                <div style={{ maxWidth: '100%' }} className="tabledata">
                                  <MaterialTable
                                    icons={tableIcons}
                                    className="client-listing"
                                    columns={[
                                      {
                                        title: 'Patient Name',
                                        field: 'patientName',
                                        render: (rowData) => {
                                          let patientName = this.get_hidden_string(rowData.patientName)
                                          let visiblityDiv = { display: 'block' };

                                          return (
                                            <>
                                              {
                                                rowData.patientName != "" ? <div>
                                                  <Link id={`Popover${rowData.ptKey}`} >{patientName}</Link>
                                                  <Popover className="screened-patient-popup" placement="right" isOpen={this.state.popoverOpen && this.state.selectedPtKey == rowData.ptKey} target={`Popover${rowData.ptKey}`} toggle={(e) => this.toggle(rowData.ptKey, rowData.nickName)}>
                                                    <PopoverHeader style={{ backgroundColor: "#34bfa3", color: "#fff" }}>
                                                      Patient Info <FontAwesomeIcon style={{ float: "right", cursor: "pointer" }} onClick={this.outsideClick} icon={["fa", "times"]} />
                                                    </PopoverHeader>
                                                    <Loader show={loading} message={spinner}>
                                                      <PopoverBody style={visiblityDiv}>
                                                        <div className="screen-patientinfo-block">
                                                          <div className="row">
                                                            <div className="col-6 patient-info-screened-popup">
                                                              <span className="mb-2 d-block" ><b>Name: </b>{patientName}</span>
                                                              <span className="mb-2" ><b>Brightree ID: </b>{rowData.patientId}</span>
                                                              <span className="mb-2"><b>DOB: </b>{moment(rowData.dob, 'YYYY-MM-DD').format('MM/DD/YYYY')}</span>
                                                              <span className="mb-2"><b>Phone#: </b>{rowData.phone} </span>
                                                              <span className="mb-2"><b>Referral: </b>{rowData.facilityName}</span>
                                                              <span className="mb-2"><b>Provider: </b>{rowData.healthProvider}</span>
                                                              {
                                                                (rowData.salesOrderList) && <span className="mb-2"><b>Sales Order(s): </b>{rowData.salesOrderList}</span>
                                                              }
                                                            </div>
                                                            <div className="col-6 text-right py-2 medium-button-section">
                                                              <div>
                                                                {rowData.osaRisk == '0' && <label className="low-risk-btn">{osaRiskValue[rowData.osaRisk]}</label>}
                                                                {rowData.osaRisk == '1' && <label className="medium-risk-btn">{osaRiskValue[rowData.osaRisk]}</label>}
                                                                {rowData.osaRisk == '2' && <label className="high-risk-btn">{osaRiskValue[rowData.osaRisk]}</label>}
                                                              </div>
                                                              <div>
                                                                <Link className="screener-data-link-pos" id={`ScreenerPopoverPopup${rowData.ptKey}`}>Screener Result</Link><Link className="screener-data-link-pos" onClick={(e) => this.setScreenerData(rowData.ptKey, rowData.nickName, false)}>Download Screener Result</Link></div>
                                                              <Popover className="ScreenerDatapopup"
                                                                isOpen={this.state.isOpenScreenerDataPopover}
                                                                target={`ScreenerPopoverPopup${rowData.ptKey}`}
                                                                toggle={(e) => this.setScreenerData(rowData.ptKey, rowData.nickName, true)}
                                                              >
                                                                <PopoverHeader style={{ backgroundColor: "transparent", color: "#000", borderBottom: "none" }}>
                                                                  <FontAwesomeIcon style={{ float: "right", cursor: "pointer" }} icon={["fa", "times"]} onClick={(e) => this.setState({ isOpenScreenerDataPopover: false })} />
                                                                  <b style={{ fontSize: "1.375rem", marginBottom: "15px", textTransform: 'uppercase', fontWeight: '500' }}>Have you been diagnosed and/or are you currently being treated for any of the following conditions?</b>
                                                                </PopoverHeader>
                                                                <Loader show={loading} message={spinner}>
                                                                  <PopoverBody>
                                                                    <div className="add-datastatus-followuptab">
                                                                      <div className="row">

                                                                        <div className="screener-data-list">
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.diabetes === 1) ? true : false} id="chkDiabetes" placeholder="List Users" class="form-control " value="1" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Diabetes</label>
                                                                          </div>
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.hypertension === 1) ? true : false} id="chkHypertension" placeholder="List Users" class="form-control " value="2" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Hypertension</label>
                                                                          </div>
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.generalFatigue === 1) ? true : false} id="chkGeneralFatigue" placeholder="List Users" class="form-control " value="3" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>General Fatigue</label>
                                                                          </div>
                                                                          <div>
                                                                            <input type="checkbox" checked={(this.state.screenerData && this.state.screenerData.obesity === 1) ? true : false} id="chkObesity" placeholder="List Users" class="form-control " value="4" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Obesity</label>
                                                                          </div>
                                                                          <div>
                                                                            <input type="checkbox" checked={(this.state.screenerData && this.state.screenerData.congestiveHeartFailure === 1) ? true : false} id="chkCongestiveHeartFailure" placeholder="List Users" class="form-control " value="5" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Congestive Heart Failure</label>
                                                                          </div>
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.pacemakers === 1) ? true : false} id="chkPacemakers" placeholder="List Users" class="form-control " value="6" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Pacemakers</label>
                                                                          </div>
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.atrialFibrillation === 1) ? true : false} id="chkAtrialFibrillation" placeholder="List Users" class="form-control " value="7" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Atrial Fibrillation </label>
                                                                          </div>
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.coronaryArteryDisease === 1) ? true : false} id="chkCoronaryArteryDisease" placeholder="List Users" class="form-control " value="8" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Coronary Artery Disease</label>
                                                                          </div>
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.stroke === 1) ? true : false} id="chkStroke" placeholder="List Users" class="form-control " value="9" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Stroke</label>
                                                                          </div>
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.severeBackPain === 1) ? true : false} id="chkSevereBackPain" placeholder="List Users" class="form-control " value="10" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Severe Back Pain</label>
                                                                          </div>
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.jointPain === 1) ? true : false} id="chkJointPain" placeholder="List Users" class="form-control " value="11" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Joint Pain</label>
                                                                          </div>
                                                                          <div>
                                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.highCholesterol === 1) ? true : false} id="chkHigh Cholesterol" placeholder="List Users" class="form-control " value="12" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>High Cholesterol</label>
                                                                          </div>
                                                                        </div>

                                                                        <div className="choose-options-select">
                                                                          <h3>Snoring?<span style={{ color: "red" }}>*</span></h3>
                                                                          <label style={{ marginBottom: "10px" }}>Do you Snore Loudy(loud enough to be heard through closed doors or your bed-partner elbows you for snoring at night)?</label>
                                                                          <div className="yes-option">
                                                                            <input type="radio" checked={this.state.screenerData.snoring === 1} name="snoring"
                                                                              value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Yes</label>
                                                                          </div>
                                                                          <div className="no-option">
                                                                            <input type="radio" id="no" checked={this.state.screenerData.snoring === 0} name="snoring" value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>No</label>
                                                                          </div>
                                                                        </div>

                                                                        <div className="choose-options-select">
                                                                          <h3>Tired?<span style={{ color: "red" }}>*</span></h3>
                                                                          <label style={{ marginBottom: "10px" }}>Do you often feel tired, Fatigued, or Sleepy during the day time(Such as falling asleep during driving or talking to someone)?</label>
                                                                          <div className="yes-option">
                                                                            <input type="radio" id="yes" checked={this.state.screenerData.tired === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Yes</label>
                                                                          </div>
                                                                          <div className="no-option">
                                                                            <input type="radio" id="no" checked={this.state.screenerData.tired === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>No</label>
                                                                          </div>
                                                                        </div>


                                                                        <div className="choose-options-select">
                                                                          <h3>Observed?<span style={{ color: "red" }}>*</span></h3>
                                                                          <label style={{ marginBottom: "10px" }}>Has any one observed you stop breathing or choking/gasping during your sleep? </label>
                                                                          <div className="yes-option">
                                                                            <input type="radio" id="yes" checked={this.state.screenerData.observed === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Yes</label>
                                                                          </div>
                                                                          <div className="no-option">
                                                                            <input type="radio" id="no" checked={this.state.screenerData.observed === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>No</label>
                                                                          </div>
                                                                        </div>


                                                                        <div className="choose-options-select">
                                                                          <h3>Pressure?<span style={{ color: "red" }}>*</span></h3>
                                                                          <label style={{ marginBottom: "10px" }}>Do you have or are being treated for high blood pressure?</label>
                                                                          <div className="yes-option">
                                                                            <input type="radio" id="yes" checked={this.state.screenerData.pressure === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Yes</label>
                                                                          </div>
                                                                          <div className="no-option">
                                                                            <input type="radio" id="no" checked={this.state.screenerData.pressure === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>No</label>
                                                                          </div>
                                                                        </div>

                                                                        <div className="choose-options-select">
                                                                          <h3>Body mass index more than 35 KG/M2?<span style={{ color: "red" }}>*</span></h3>
                                                                          <div className="yes-option">
                                                                            <input type="radio" id="yes" checked={this.state.screenerData.bodyMass === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Yes</label>
                                                                          </div>
                                                                          <div className="no-option">
                                                                            <input type="radio" id="no" checked={this.state.screenerData.bodyMass === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>No</label>
                                                                          </div>
                                                                        </div>


                                                                        <div className="choose-options-select">
                                                                          <h3>Age older than 50?<span style={{ color: "red" }}>*</span></h3>
                                                                          <div className="yes-option">
                                                                            <input type="radio" id="yes" checked={this.state.screenerData.ageOlder === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Yes</label>
                                                                          </div>
                                                                          <div className="no-option">
                                                                            <input type="radio" id="no" checked={this.state.screenerData.ageOlder === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>No</label>
                                                                          </div>
                                                                        </div>

                                                                        <div className="choose-options-select">
                                                                          <h3>Neck size large?(Measured around ADAMS Apple)<span style={{ color: "red" }}>*</span></h3>
                                                                          <label style={{ marginBottom: "10px" }}>Is your shirt collar 16 inches / 40cm or larger?</label>
                                                                          <div className="yes-option">
                                                                            <input type="radio" id="yes" checked={this.state.screenerData.neckSize === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Yes</label>
                                                                          </div>
                                                                          <div className="no-option">
                                                                            <input type="radio" id="no" checked={this.state.screenerData.neckSize === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>No</label>
                                                                          </div>
                                                                        </div>

                                                                        <div className="choose-options-select">
                                                                          <h3>gender = male<span style={{ color: "red" }}>*</span></h3>

                                                                          <div className="yes-option">
                                                                            <input type="radio" id="yes" checked={this.state.screenerData.genderMale === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>Yes</label>
                                                                          </div>
                                                                          <div className="no-option">
                                                                            <input type="radio" id="no" checked={this.state.screenerData.genderMale === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                                            <label>No</label>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </PopoverBody>
                                                                </Loader>
                                                              </Popover>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </PopoverBody>
                                                      {
                                                        (this.state.sleepScreenerAccess == 2) && <>

                                                          <PopoverHeader style={{ backgroundColor: "#34bfa3", color: "#fff" }}> Follow-Up Status </PopoverHeader>
                                                          {/* <PopoverHeader style={{ backgroundColor: "#34bfa3", color: "#FFF" }}><FontAwesomeIcon icon={["fa", "clipboard-check"]} /> Adherence Info, AHI, Leaks</PopoverHeader> */}
                                                          <PopoverBody style={visiblityDiv}>
                                                            <div className="row">
                                                              {
                                                                (rowData.followUpStatus && !this.state.isPendingSleepyDropDownOpen) && <button type="button" onClick={() => { this.setState({ isPendingSleepyDropDownOpen: true }) }} className={`pending-sleep-study-btn ${this.state.isPendingSleepStudyDataExist ? this.state.isPendingSleepStudyDataExist.replace(/:|\s/g, "") : rowData.followUpStatus.replace(/:|\s/g, "")}`}> {this.state.isPendingSleepStudyDataExist ? this.state.isPendingSleepStudyDataExist : rowData.followUpStatus} </button>
                                                              }
                                                              {
                                                                this.state.isPendingSleepyDropDownOpen && <>
                                                                  <select value={this.state.isPendingSleepStudyDataExist ? this.state.isPendingSleepStudyDataExist : rowData.followUpStatus} onChange={(e) => this.savePendingSleepyStatus(e, rowData.followUpStatus, rowData.ptKey, rowData.nickName)} className="form-control col-md-6" >
                                                                    <option value="New Result">New Result</option>
                                                                    <option value="Discussed with Provider">Discussed with Provider</option>
                                                                    <option value="Pending Provider Review with Patient">Pending Provider Review with Patient</option>
                                                                    <option value="Pending Sleep Study">Pending Sleep Study</option>
                                                                    <option value="Closed: Patient Successfully on Therapy">Closed: Patient Successfully on Therapy</option>
                                                                    <option value="Closed: Therapy Not Needed">Closed: Therapy Not Needed</option>
                                                                    <option value="Closed: Unsuccessful - Other">Closed: Unsuccessful - Other</option>
                                                                  </select>
                                                                  <button type="button" class="btn btn-default add-btn-follow-up cancle-btn pending-btm" onClick={() => this.setState({ isPendingSleepyDropDownOpen: false })}>Cancel</button>
                                                                </>
                                                              }
                                                            </div>
                                                            <div className="row">
                                                              <div className="addnotes-patients">
                                                                <p className="notes-add-head">Notes</p>
                                                                {/* <button type="button" class="btn-primary add-btn-follow-up">Add </button> */}
                                                                <Link id="open-patient-module" onClick={() => this.setState({ isPatientNoteError: false })} className="btn-primary add-btn-follow-up">Add</Link>
                                                              </div>
                                                            </div>
                                                            <table className="follow-up-table" style={{ border: "1px solid #000", color: "#000", width: '100%' }}>
                                                              <tbody >
                                                                {
                                                                  this.props.patientNotesList && this.props.patientNotesList.length > 0 &&
                                                                  this.props.patientNotesList.map((data, i) => (
                                                                    <tr key={i}>
                                                                      <td style={{ width: "120px", textAlign: 'center' }}>{data.updatedOnDate}</td>
                                                                      <td style={{ width: "120px" }}>{data.createdBy}</td>
                                                                      <td className="patient-info-add-link active" style={{ textDecoration: 'underline', padding: '15', color: 'blue' }} onClick={() => this.updateModelOpen(data)}>
                                                                        {data.description}
                                                                      </td>
                                                                      {/* <td style={{ width: "50px", textAlign: 'center'}}>
                                                                              <FontAwesomeIcon title="Delete" className="" style={{ width: "50px", textAlign: 'center', height: '15 px', cursor: 'pointer' }} icon={["fa", "trash"]} onClick={() => this.displayAlert("Are you sure?", "You want to delete this note ?", 'deleteConfirmation', data)} />
                                                                      </td> */}
                                                                    </tr>
                                                                  ))
                                                                }
                                                              </tbody>
                                                            </table>
                                                            <div className="row">
                                                              <Popover className="add-data-popup"
                                                                isOpen={this.state.isPatientNoteModelOpen}
                                                                target='open-patient-module'
                                                                toggle={(e) => this.isPatientNoteModelOpen()}
                                                              >
                                                                <PopoverHeader style={{ backgroundColor: "#34bfa3", color: "#FFF" }}> Patient Note
                                                                                                            <FontAwesomeIcon
                                                                    style={{ float: "right", cursor: "pointer" }}
                                                                    onClick={(e) => this.isPatientNoteModelOpen()}
                                                                    icon={["fa", "times"]}
                                                                  />
                                                                </PopoverHeader>
                                                                <PopoverBody style={visiblityDiv}>
                                                                  <div className="add-datastatus-followuptab">
                                                                    <div className="row">
                                                                      <textarea rows="10"
                                                                        id="notes"
                                                                        className="form-control add-data-textfield"
                                                                        type="text"
                                                                        value={this.state.patientData}
                                                                        placeholder="Enter note"
                                                                        maxLength="500"
                                                                        onChange={(e) => this.setState({ patientData: e.target.value })}
                                                                      />
                                                                      {this.state.isPatientNoteError == true && <span className="error-msg text-danger">Please enter note.</span>}
                                                                      <div className="follow-up-btns mt-2">
                                                                        {
                                                                          (this.state.isUpdateModel) ?
                                                                            (
                                                                              <button type="button" class="btn-primary add-btn-follow-up" onClick={() => this.updatePatientData()}>Save</button>
                                                                            ) :
                                                                            (<button type="button" class="btn-primary add-btn-follow-up" onClick={() => this.savePatientData(rowData)}>Save</button>)
                                                                        }
                                                                        <button type="button" class="btn btn-default add-btn-follow-up cancle-btn" onClick={() => this.isPatientNoteModelOpen()}>Cancel</button>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </PopoverBody>
                                                              </Popover>
                                                            </div>
                                                          </PopoverBody>

                                                        </>
                                                      }
                                                    </Loader>
                                                  </Popover>
                                                </div> : "-"
                                              }
                                            </>
                                          )
                                        }
                                      },
                                      {
                                        title: 'Screening Date',
                                        field: 'screeningDate',
                                        type: "date",
                                        width: "150px",
                                        ...this.state.currentSortOrder,
                                        render: rowData => {
                                          return rowData.screeningDate ? rowData.screeningDate : '-';
                                        }
                                      },
                                      {
                                        title: 'OSA Risk',
                                        icon: 'favorite_border',
                                        field: 'osaRisk',
                                        hidden: this.state.orderStatusIsHidden,
                                        cellStyle: {
                                          verticalAlign: "middle"
                                        },
                                        render: rowData => {
                                          return (
                                            <div >
                                              <div className="low-risk-popover">
                                                {/* <p style={{ color: "#FFF", width: 180, backgroundColor: colors[rowData.orderStatus], borderRadius: 10, textAlign: "center" }}> */}
                                                {/* </p> */}
                                                {rowData.osaRisk == '0' && <label className="low-risk-btn" id='test-main-osq' >{osaRiskValue[rowData.osaRisk]}</label>}
                                                {rowData.osaRisk == '1' && <label className="medium-risk-btn" id='test-main-osq' >{osaRiskValue[rowData.osaRisk]}</label>}
                                                {rowData.osaRisk == '2' && <label className="high-risk-btn" id='test-main-osq' >{osaRiskValue[rowData.osaRisk]}</label>}
                                                {/* <button type="button" className = "medium-risk-btn">Medium Risk </button>
                                                                              <button type="button" className = "high-risk-btn">High Risk</button> */}

                                              </div>
                                            </div>
                                          )
                                        },
                                      },
                                      {
                                        title: 'Screener Result',
                                        field: 'orderNote',
                                        sorting: false,
                                        hidden: this.state.orderNoteIsHidden,
                                        render: rowData => {
                                          return (
                                            <div>
                                              <Link id={`ScreenerPopover${rowData.ptKey}`}>Link</Link>
                                              <Popover className="ScreenerDatapopup"
                                                isOpen={this.state.isOpenScreenerDataPopover}
                                                target={`ScreenerPopover${rowData.ptKey}`}
                                                toggle={(e) => this.setScreenerData(rowData.ptKey, rowData.nickName, true)}
                                              >
                                                <PopoverHeader style={{ backgroundColor: "transparent", color: "#000", borderBottom: "none" }}>
                                                  <FontAwesomeIcon style={{ float: "right", cursor: "pointer" }} icon={["fa", "times"]} onClick={(e) => this.setState({ isOpenScreenerDataPopover: false })} />
                                                  <b style={{ fontSize: "1.375rem", marginBottom: "15px", textTransform: 'uppercase', fontWeight: '500' }}>Have you been diagnosed and/or are you currently being treated for any of the following conditions?</b>
                                                </PopoverHeader>
                                                <Loader show={loading} message={spinner}>
                                                  <PopoverBody>
                                                    <div className="add-datastatus-followuptab">
                                                      <div className="row">

                                                        <div className="screener-data-list">
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.diabetes === 1) ? true : false} id="chkDiabetes" placeholder="List Users" class="form-control " value="1" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Diabetes</label>
                                                          </div>
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.hypertension === 1) ? true : false} id="chkHypertension" placeholder="List Users" class="form-control " value="2" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Hypertension</label>
                                                          </div>
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.generalFatigue === 1) ? true : false} id="chkGeneralFatigue" placeholder="List Users" class="form-control " value="3" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>General Fatigue</label>
                                                          </div>
                                                          <div>
                                                            <input type="checkbox" checked={(this.state.screenerData && this.state.screenerData.obesity === 1) ? true : false} id="chkObesity" placeholder="List Users" class="form-control " value="4" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Obesity</label>
                                                          </div>
                                                          <div>
                                                            <input type="checkbox" checked={(this.state.screenerData && this.state.screenerData.congestiveHeartFailure === 1) ? true : false} id="chkCongestiveHeartFailure" placeholder="List Users" class="form-control " value="5" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Congestive Heart Failure</label>
                                                          </div>
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.pacemakers === 1) ? true : false} id="chkPacemakers" placeholder="List Users" class="form-control " value="6" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Pacemakers</label>
                                                          </div>
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.atrialFibrillation === 1) ? true : false} id="chkAtrialFibrillation" placeholder="List Users" class="form-control " value="7" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Atrial Fibrillation </label>
                                                          </div>
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.coronaryArteryDisease === 1) ? true : false} id="chkCoronaryArteryDisease" placeholder="List Users" class="form-control " value="8" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Coronary Artery Disease</label>
                                                          </div>
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.stroke === 1) ? true : false} id="chkStroke" placeholder="List Users" class="form-control " value="9" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Stroke</label>
                                                          </div>
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.severeBackPain === 1) ? true : false} id="chkSevereBackPain" placeholder="List Users" class="form-control " value="10" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Severe Back Pain</label>
                                                          </div>
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.jointPain === 1) ? true : false} id="chkJointPain" placeholder="List Users" class="form-control " value="11" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Joint Pain</label>
                                                          </div>
                                                          <div>
                                                            <input name="chkExistingConditions" type="checkbox" checked={(this.state.screenerData && this.state.screenerData.highCholesterol === 1) ? true : false} id="chkHigh Cholesterol" placeholder="List Users" class="form-control " value="12" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>High Cholesterol</label>
                                                          </div>
                                                        </div>

                                                        <div className="choose-options-select">
                                                          <h3>Snoring?<span style={{ color: "red" }}>*</span></h3>
                                                          <label style={{ marginBottom: "10px" }}>Do you Snore Loudy(loud enough to be heard through closed doors or your bed-partner elbows you for snoring at night)?</label>
                                                          <div className="yes-option">
                                                            <input type="radio" checked={this.state.screenerData.snoring === 1} name="snoring"
                                                              value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Yes</label>
                                                          </div>
                                                          <div className="no-option">
                                                            <input type="radio" id="no" checked={this.state.screenerData.snoring === 0} name="snoring" value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>No</label>
                                                          </div>
                                                        </div>

                                                        <div className="choose-options-select">
                                                          <h3>Tired?<span style={{ color: "red" }}>*</span></h3>
                                                          <label style={{ marginBottom: "10px" }}>Do you often feel tired, Fatigued, or Sleepy during the day time(Such as falling asleep during driving or talking to someone)?</label>
                                                          <div className="yes-option">
                                                            <input type="radio" id="yes" checked={this.state.screenerData.tired === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Yes</label>
                                                          </div>
                                                          <div className="no-option">
                                                            <input type="radio" id="no" checked={this.state.screenerData.tired === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>No</label>
                                                          </div>
                                                        </div>


                                                        <div className="choose-options-select">
                                                          <h3>Observed?<span style={{ color: "red" }}>*</span></h3>
                                                          <label style={{ marginBottom: "10px" }}>Has any one observed you stop breathing or choking/gasping during your sleep? </label>
                                                          <div className="yes-option">
                                                            <input type="radio" id="yes" checked={this.state.screenerData.observed === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Yes</label>
                                                          </div>
                                                          <div className="no-option">
                                                            <input type="radio" id="no" checked={this.state.screenerData.observed === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>No</label>
                                                          </div>
                                                        </div>


                                                        <div className="choose-options-select">
                                                          <h3>Pressure?<span style={{ color: "red" }}>*</span></h3>
                                                          <label style={{ marginBottom: "10px" }}>Do you have or are being treated for high blood pressure?</label>
                                                          <div className="yes-option">
                                                            <input type="radio" id="yes" checked={this.state.screenerData.pressure === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Yes</label>
                                                          </div>
                                                          <div className="no-option">
                                                            <input type="radio" id="no" checked={this.state.screenerData.pressure === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>No</label>
                                                          </div>
                                                        </div>

                                                        <div className="choose-options-select">
                                                          <h3>Body mass index more than 35 KG/M2?<span style={{ color: "red" }}>*</span></h3>
                                                          <div className="yes-option">
                                                            <input type="radio" id="yes" checked={this.state.screenerData.bodyMass === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Yes</label>
                                                          </div>
                                                          <div className="no-option">
                                                            <input type="radio" id="no" checked={this.state.screenerData.bodyMass === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>No</label>
                                                          </div>
                                                        </div>


                                                        <div className="choose-options-select">
                                                          <h3>Age older than 50?<span style={{ color: "red" }}>*</span></h3>
                                                          <div className="yes-option">
                                                            <input type="radio" id="yes" checked={this.state.screenerData.ageOlder === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Yes</label>
                                                          </div>
                                                          <div className="no-option">
                                                            <input type="radio" id="no" checked={this.state.screenerData.ageOlder === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>No</label>
                                                          </div>
                                                        </div>

                                                        <div className="choose-options-select">
                                                          <h3>Neck size large?(Measured around ADAMS Apple)<span style={{ color: "red" }}>*</span></h3>
                                                          <label style={{ marginBottom: "10px" }}>Is your shirt collar 16 inches / 40cm or larger?</label>
                                                          <div className="yes-option">
                                                            <input type="radio" id="yes" checked={this.state.screenerData.neckSize === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Yes</label>
                                                          </div>
                                                          <div className="no-option">
                                                            <input type="radio" id="no" checked={this.state.screenerData.neckSize === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>No</label>
                                                          </div>
                                                        </div>

                                                        <div className="choose-options-select">
                                                          <h3>gender = male<span style={{ color: "red" }}>*</span></h3>

                                                          <div className="yes-option">
                                                            <input type="radio" id="yes" checked={this.state.screenerData.genderMale === 1} value="Yes" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>Yes</label>
                                                          </div>
                                                          <div className="no-option">
                                                            <input type="radio" id="no" checked={this.state.screenerData.genderMale === 0} value="No" style={{ height: "18px", width: "18px", color: "rgb(87, 89, 98)" }} />
                                                            <label>No</label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </PopoverBody>
                                                </Loader>
                                              </Popover>

                                            </div>

                                          )
                                        },
                                      },
                                      {
                                        title: 'Download Result',
                                        field: 'facilityName',
                                        search: false,
                                        render: rowData => {
                                          return <Link onClick={() => this.setScreenerData(rowData.ptKey, rowData.nickName, false)}>Download</Link>
                                        },
                                      },
                                      {
                                        title: 'Referral',
                                        field: 'facilityName',
                                        hidden: this.state.facilityName,
                                        render: rowData => {
                                          return rowData.facilityName ? rowData.facilityName : '-';
                                        },
                                      },
                                      {
                                        title: 'Provider',
                                        field: 'healthProvider',
                                        render: rowData => {
                                          return rowData.healthProvider ? rowData.healthProvider : '-';
                                        },
                                      },
                                      {
                                        title: 'Status',
                                        field: 'followUpStatus',
                                        hidden: (this.state.sleepScreenerAccess == 2) ? false : true,
                                        cellStyle: {
                                          verticalAlign: "middle"
                                        },
                                        render: rowData => {
                                          return (
                                            <div>
                                              { rowData.followUpStatus == 'New Result' && <Link className="test-result-btn" id='test-result-btn' >New Result</Link>}
                                              { rowData.followUpStatus == 'Discussed with Provider' && <Link className="discussed-result-btn" id='discussed-result-btn' >Discussed with Provider</Link>}
                                              { rowData.followUpStatus == 'Pending Sleep Study' && <Link className="pending-list-button-status" id='pending-list-button-status' >Pending Sleep Study</Link>}
                                              { rowData.followUpStatus == 'Closed: Patient Successfully on Therapy' && <Link className="therapy-result-btn" id='therapy-result-btn' >Closed: Patient Successfully on Therapy</Link>}
                                              { rowData.followUpStatus == 'Closed: Therapy Not Needed' && <Link className="therapy-not-needed" id='therapy-not-needed' >Closed: Therapy Not Needed</Link>}
                                              { rowData.followUpStatus == 'Closed: Unsuccessful - Other' && <Link className="therapy-not-needed" id='therapy-not-needed' >Closed: Unsuccessful - Other</Link>}
                                              { rowData.followUpStatus == 'Pending Provider Review with Patient' && <Link className="pending-provider-review-with-patient-result-btn" id='pending-provider-review-with-patient-result-btn' >Pending Provider Review with Patient</Link>}
                                            </div>
                                          )
                                        },
                                      },
                                    ]}
                                    data={this.state.user ? this.state.user : []}
                                    totalCount={this.state.user ? this.state.user.length : 0}
                                    isLoading={this.state.isLoading}
                                    onOrderChange={this.changeOrderByPap}
                                    localization={{
                                      body: {
                                        emptyDataSourceMessage: this.state.isLoading
                                          ? "Loading..." : "No patient to display"
                                      }
                                    }}
                                    options={{
                                      maxBodyHeight: 350,
                                      minBodyHeight: this.state.totalRecords == 350 ? 350 : 350,
                                      overflowY: "auto",
                                      padding: "dense",
                                      searchFieldAlignment: 'left',
                                      showTitle: false,
                                      toolbar: true,
                                      actionsColumnIndex: -1,
                                      search: true,
                                      draggable: false,
                                      pageSize: 100,
                                      cellStyle: {
                                        padding: "10px",
                                        color: '#575962',
                                        fontSize: "13px",
                                      },
                                      headerStyle: {
                                        backgroundColor: '#f4f3f8',
                                        color: '#575962',
                                        padding: "15px 10px",
                                        fontSize: "13px",
                                      },
                                      paging: this.state.user.length == 0 ? false : true,
                                      pageSizeOptions: [5, 10, 20, 50, 100]
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                {
                  this.state.isOpenOsaRiskPopover && (
                    <Popover className="lowRiskpopup"
                      isOpen={this.state.isOpenOsaRiskPopover}
                      target='test-main-osq'
                      toggle={(e) => this.setState({ isOpenOsaRiskPopover: false })}
                    >
                      <div className="explanation-scoring">
                        <h6 style={{ backgroundColor: "#ffaec9", color: "#000" }}><b>STOP-BANG Scoring Explanation</b><FontAwesomeIcon
                          style={{ float: "right", cursor: "pointer" }}
                          onClick={(e) => this.setState({ isOpenOsaRiskPopover: false })}
                          icon={["fa", "times"]}
                        /></h6>
                        <ul className="risk-low-list">
                          <li>For General Population:</li>
                          <li>OSA - Low Risk : Yes to 0 - 2 questions</li>
                          <li>OSA - Intermediate Risk : Yes to 3 - 4 questions</li>
                          <li>OSA - High Risk : Yes to 5 - 8 questions</li>
                          <li>or Yes to 2 or more of 4 STOP questions + male gender</li>
                          <li>or Yes to 2 or more of 4 STOP questions + BMI > 35kg/m2</li>
                          <li>or Yes to 2 or more of 4 STOP questions + neck circumference 16 inch</li>
                        </ul>
                      </div>
                      <PopoverHeader style={{ backgroundColor: "#34bfa3", color: "#000" }}> <b>The Risk of suffering from Moderate or Severe Obstructive Sleep Apnea</b>
                      </PopoverHeader>

                      <PopoverBody>
                        <div className="add-datastatus-followuptab">
                          <div className="row">
                            <div className="col-4 low-risk-left">
                              <img src="/images/graph-popup.png" />
                              <p>Anesthesiology 2008; 108(5):812-821</p>
                            </div>
                            <div className="col-8 low-risk-right">
                              <ul className="risk-low-list">
                                <li>If the STOP-Bang score is <span>3</span> vs. 0-2, the risk of obstructive sleep apnea is <span>2.5 fold.</span></li>
                                <li>If the STOP-Bang score is <span>4</span> vs. 0-2, the risk of obstructive sleep apnea is <span>3 fold.</span></li>
                                <li>If the STOP-Bang score is <span>5</span> vs. 0-2, the risk of obstructive sleep apnea is <span>5 fold.</span></li>
                                <li>If the STOP-Bang score is <span>6</span> vs. 0-2, the risk of obstructive sleep apnea is <span>6 fold.</span></li>
                                <li>If the STOP-Bang score is <span>7</span> or 8 vs. vs. 0-2, the risk of obstructive sleep apnea is <span>7 fold.</span></li>

                              </ul>
                              <p>Chung F, Subramanyam R, Liao P, Sasaki E, Shapiro C, Sun Y. Br J Anaesth 2012; 108:768-75</p>
                            </div>
                          </div>
                          <div className="col-12">
                            <p>Chung F, Subramanyam R, Liao P, Sasaki E, Shapiro C, Sun Y. Br J Anaesth 2012; 108:768-75</p>
                          </div>
                        </div>
                      </PopoverBody>

                    </Popover>
                  )
                }
              </div>
            </div>
          </div>
        </div>

      </>
    )
  }
}

ScreenedPatient = reduxForm({
  form: 'ScreenedPatient',
  // validate,
  asyncValidate,
  enableReinitialize: true,
  destroyOnUnmount: false
})(ScreenedPatient);

function mapStateToProps(state, props) {
  return {
    sloading: state.auth.sloading,
    loading: state.auth.loading,
    PtKey: state.auth.user.PtKey,
    referralParam: state.auth.referralParam,
    organizationParam: state.auth.organizationParam,
    roleId: state.auth.user.roleId,
    userId: state.auth.user.userId,
    isPapUser: state.auth.user.isPapUser,
    globalSummaryAccess: state.auth.user.globalSummaryAccess,
    sleepScreenerAccess: state.auth.user.sleepScreenerAccess,
    checkForMenuItemAccess: state.auth.checkForMenuItemAccessresponse != undefined ? state.auth.checkForMenuItemAccessresponse : [],
    //isPapUser: 0,
    userData: state.auth.fetchScreenedPatientListresponse != undefined ? state.auth.fetchScreenedPatientListresponse.liScreenedPatientListResponse : [],
    patientScreenerData: state.auth.fetchScreenerDataListresponse != undefined ? state.auth.fetchScreenerDataListresponse.liScreenerDataResponse : [],
    locationPath: state.auth.fetchScreenerDataListresponse != undefined ? state.auth.fetchScreenerDataListresponse : undefined,
    patientNotesList: state.auth.fetchPatientNotesListresponse != undefined ? state.auth.fetchPatientNotesListresponse.liPatientNotesResponse : [],
    patientNoteAdd: state.auth.setAddPatientNotesResponse != undefined ? state.auth.setAddPatientNotesResponse.liPatientNotesResponse : [],
    patientNoteDelete: state.auth.deletePatientNoteResponse != undefined ? state.auth.deletePatientNoteResponse : [],
    profile: state.Profile,
    initialValues: {
      firstName: state.auth.firstName,
      lastName: state.auth.lastName,
      Email: state.auth.email,
      PhoneNumber: state.auth.phone,
      // imagePath: state.auth.user[0].ImagePath,
    },

    response: state.auth.response,
    // imagePath: state.auth.user[0].ImagePath,
    responseProfileImg: state.auth.responseProfileImg,
    filterRes: state.auth.filterRes,
    salesFilter: state.auth.salesFilter,
    isScrollToList: state.auth.isScrollToList,
    isFilterClear: state.auth.isFilterClear,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearFilter: (data) => dispatch(auth.actions.clearFilter(data)),
    fetchScreenedPatientListRequest: (referralParam) => {
      dispatch(auth.actions.fetchScreenedPatientListRequest(referralParam))
    },
    fetchPatientNotesListRequest: (referralParam) => {
      dispatch(auth.actions.fetchPatientNotesListRequest(referralParam))
    },
    fetchScreenerDataListRequest: (referralParam) => {
      dispatch(auth.actions.fetchScreenerDataListRequest(referralParam))
    },
    setAddPatientNotesRequest: (data) => {
      dispatch(auth.actions.setAddPatientNotesRequest(data))
    },
    setPandingSleepStudyRequest: (data) => {
      dispatch(auth.actions.setPandingSleepStudyRequest(data))
    },
    saveSalesFilter: (data, isScrollToList) => dispatch(auth.actions.saveSalesFilter(data, isScrollToList)),
    deletePatientNoteRequest: (data) => dispatch(auth.actions.deletePatientNoteRequest(data)),
    checkForMenuItemAccessRequest: () => {
      dispatch(auth.actions.checkForMenuItemAccessRequest())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenedPatient);
